export enum CooperativeQueryKeys {
  GET_ALL = "GET_ALL",
}
